import { PayloadBrandContextComplete } from "../../components/onboardingHome/OnboardingLayoutHome";
import { axiosInstanceWebsite, axiosInstanceConversationalEngine } from "../instance";

export interface CreateHomeData {
	brand_name: string;
	funnels: string[];
	context: string;
    configurations?: {
        [key: string]: unknown;
    }
    template_design?: {
        [key: string]: unknown;
    };
    parent_id?: string;
    subdomain?: string;
}

export const getHomesList = async () => {
    const response = await axiosInstanceWebsite.get(`/store`);
    return response.data;
};

export const deleteHomeById = async (id: string) => {
    const response = await axiosInstanceWebsite.delete(`/store/${id}`);
    return response.data;
};

export const postDuplicateHome = async (id: string) => {
    const response = await axiosInstanceWebsite.post(`/store/${id}/clone`);
    return response.data;
};

export const getBrandContext = async (data: PayloadBrandContextComplete) => {
    const response = await axiosInstanceConversationalEngine.post(`/store/brand-context-resolver`, data);
    return response.data;
};

export const postCreateHome = async (data: CreateHomeData) => {
    const response = await axiosInstanceWebsite.post(`/store`, data);
    return response.data;
};
